import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import axios from "axios";

import moment from 'moment'

export default function UserInvitedFriendsTool(props) {
    const {
        userId
    } = props;

    const [friends, setFriends] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userId == undefined) {
            return;
        }
        setLoading(true);
        axios.get(`/referral/user/invites?userId=${userId}`).then(d => d.data.result.users).then(arr => {
            console.log("arr = ", arr);
            setFriends(arr);
            setLoading(false);
        });
    }, [userId]);

    if (friends.length == 0 && loading == true) {
        return (
            <div>
                загрузка...
            </div>
        );
    }

    return (
        <Wrapper>

            {friends.length == 0 ?
                <div>
                    нет приглашенных друзей
                </div>
                :
                <div>
                    <div>
                        {`Приглашенные друзья(${friends.length}): `}
                    </div>
                    {friends.map((a, i) => {
                        return (
                            <UserRow key={a.id} className={'flex flex-row items-center justify-between'} >
                                <div>
                                    {`${+i + 1}) ${a.email}`}
                                </div>
                                <div className={'ml-2 text-sm text-gray-400'} >
                                    {`${moment(a.timestamp).format("DD.MM.YYYY HH:mm")}`}
                                </div>
                            </UserRow>
                        );
                    })}
                </div>
            }

        </Wrapper>
    );
}

const Wrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

const UserRow = styled.div`
  padding: 5px;
  border-bottom: 1px solid #ccc;
`;